export default __webpack_public_path__ + "3c50ce966a45eb74ae938807554e6a69.svg";